const zoneMasterColumns = () => {
  return (
    [
      {
        Header: 'Display Sequence',
        accessor: 'displayseq',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Zone Id',
        accessor: 'zonecode',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Name',
        accessor: 'zonename',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Description',
        accessor: 'zonedesc',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      }

    ]
  )
}

export default zoneMasterColumns;
